import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RegisafePage } from './regisafe.page';
import {SuchergebnisseResolver} from '../resolver/suchergebnisse.resolver';
import {DetailResolver} from '../resolver/detail.resolver';

const routes: Routes = [
  {
    path: 'regisafe',
    component: RegisafePage,
    children: [
      {
        path: '',
        redirectTo: '/regisafe/anmeldung',
        pathMatch: 'full'
      },
      {
        path: 'anmeldung',
        loadChildren: () => import('../views/anmeldung/anmeldung.module').then(m => m.AnmeldungPageModule)
      },
      {
        path: 'suche',
        loadChildren: () => import('../views/suche/suche.module').then(m => m.SuchePageModule)
      },
      {
        path: 'suchergebnisse',
        loadChildren: () => import('../views/suchergebnisse/suchergebnisse.module').then(m => m.SuchergebnissePageModule),
        resolve: {result: SuchergebnisseResolver}
      },
      {
        path: 'suchergebnisse/:random',
        loadChildren: () => import('../views/suchergebnisse/suchergebnisse.module').then(m => m.SuchergebnissePageModule),
        resolve: {result: SuchergebnisseResolver}
      },
      {
        path: 'detail',
        loadChildren: () => import('../views/detail/detail.module').then(m => m.DetailPageModule),
        resolve: {details: DetailResolver}
      },
      {
        path: 'detail/:objid',
        loadChildren: () => import('../views/detail/detail.module').then(m => m.DetailPageModule),
        resolve: {details: DetailResolver}
      },
      {
        path: 'detail/:osid/:objid',
        loadChildren: () => import('../views/detail/detail.module').then(m => m.DetailPageModule),
        resolve: {details: DetailResolver}
      },
      {
        path: 'detail/:osid/:objid/:rand',
        loadChildren: () => import('../views/detail/detail.module').then(m => m.DetailPageModule),
        resolve: {details: DetailResolver}
      },
      {
        path: 'suche-gespeichert',
        loadChildren: () => import('../views/suche-gespeichert/suche-gespeichert.module').then(m => m.SucheGespeichertPageModule)
      },
      {
        path: 'barcode',
        loadChildren: () => import('../views/barcode/barcode.module').then(m => m.BarcodePageModule)
      },
      {
        path: 'einstellungen',
        loadChildren: () => import('../views/einstellungen/einstellungen.module').then(m => m.EinstellungenPageModule)
      },
      {
        path: 'favoriten',
        loadChildren: () => import('../views/favoriten/favoriten.module').then(m => m.FavoritenPageModule)
      },
      {
        path: 'informationen',
        loadChildren: () => import('../views/informationen/informationen.module').then(m => m.InformationenPageModule)
      },
      {
        path: 'in-bearbeitung',
        loadChildren: () => import('../views/in-bearbeitung/in-bearbeitung.module').then(m => m.InBearbeitungPageModule)
      },
      {
        path: 'zuordnen',
        loadChildren: () => import('../views/dateien-zuordnen/dateien-zuordnen.module').then(m => m.DateienZuordnenPageModule)
      },
      {
        path: 'hierarchie',
        loadChildren: () => import('../views/hierarchie/hierarchie.module').then(m => m.HierarchiePageModule)
      }
    ]
  },
  {
    path: '',
    redirectTo: '/regisafe/anmeldung',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class TabsPageRoutingModule {}
